export default {
  title: 'Zone de danger',
  description: 'Actions irréversibles et destructrices',
  deleteAccount: {
    title: 'Supprimer le compte',
    subtitle: 'Supprimer définitivement votre compte',
    warning: {
      title: 'Cette action est irréversible',
      item1: 'Toutes les sessions de ce compte sont déconnectées aussitôt',
      item2: 'Vous quittez toutes vos organisations, et les invitations que vous avez envoyées sont retirées',
      item3: 'Votre vérification en deux étapes, vos codes de secours et vos comptes de connexion liés sont supprimés',
      organizationsTitle: 'Organisations que vous possédez',
      organizationsDescription:
        "La suppression est refusée tant que vous êtes le dernier membre à pouvoir administrer l'une de ces organisations : elle resterait sans personne pour la gérer. Supprimez d'abord l'organisation, ou transférez-la à un autre membre, depuis sa Zone de danger.",
      deleteOrganization: "Supprimer l'organisation",
    },
    confirm: {
      title: "Confirmez qu'il s'agit bien de vous",
      description: 'Saisissez votre mot de passe, puis tapez la phrase ci-dessous.',
      // Compared against the user input to unlock the deletion button: label,
      // placeholder and hint all render this same phrase.
      confirmPhrase: 'SUPPRIMER MON COMPTE',
      confirmLabel: 'Tapez {text} pour confirmer',
      confirmHint: 'Tapez "{text}" exactement comme indiqué ci-dessus',
      submit: 'Supprimer mon compte définitivement',
    },
    lastAdministrator:
      'Votre compte est le dernier membre à pouvoir administrer au moins une organisation. Supprimez cette organisation, ou transférez-la à un autre membre, depuis sa Zone de danger, puis réessayez.',
  },
}
